module.exports = __webpack_public_path__ + "img/证书3.09a19b01.jpg";